import { Component, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BeaconQueryFilterDto } from '../../dto/beacon-query-filter.dto';
import { BeaconGroupService } from '../../../../spook/beacon-group/service/beacon-group.service';
import { BeaconGroupDto } from '../../../beacon-group/model/beacon-group.dto';

@Component({
  selector: 'app-beacon-filters',
  imports: [ReactiveFormsModule],
  templateUrl: './beacon-filters.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './beacon-filters.component.scss',
})
export class BeaconFiltersComponent implements OnInit {
  filterForm: FormGroup;

  groupOptions = signal<{ label: string; value: string }[]>([]);
  sortByOptions = signal<{ label: string; value: string }[]>([]);
  sortOrderOptions = signal<{ label: string; value: string }[]>([]);

  filtersApplied = output<BeaconQueryFilterDto>();

  isLoading = signal(false);
  hasError = signal(false);
  isSearching = signal(false);

  constructor(
    private _fb: FormBuilder,
    private _beaconGroupService: BeaconGroupService,
  ) {
    this.filterForm = this._fb.group({
      corporateId: [''],
      groupId: [null],
      search: [''],
      sortBy: [null],
      sortOrder: [null],
    });
  }

  ngOnInit(): void {
    this._loadFilterOptions();
  }

  private _loadFilterOptions(): void {
    this.isLoading.set(true);
    this.hasError.set(false);

    this._beaconGroupService.getBeaconGroups({ page: 0, pageSize: 100 }).subscribe({
      next: (response) => {
        if(response.success && response.data) {
          const groups = response.data.map((group: BeaconGroupDto) => ({
            label: group.name,
            value: group.id,
          }));
          this.groupOptions.set(groups);
        }
        this.isLoading.set(false);
      },
      error: () => {
        this.hasError.set(true);
        this.isLoading.set(false);
      },
    });

    this.sortByOptions.set([
      { label: 'Tracking habilitado', value: 'TRACKING_ENABLED' },
      { label: 'Fecha de última posición', value: 'REPORT_DATE' }
    ]);

    this.sortOrderOptions.set([
      { label: 'Ascendente', value: 'ASC' },
      { label: 'Descendente', value: 'DESC' },
    ]);
  }

  onApplyFilters(): void {
    const filters: BeaconQueryFilterDto = this.filterForm.value;
    this.filtersApplied.emit(filters);
  }

  onClearFilters(): void {
    this.filterForm.reset({
      corporateId: '',
      groupId: null,
      search: '',
    });
    const raw: Record<string, unknown> = this.filterForm.value;
    const cleaned = Object.fromEntries(
      Object.entries(raw).filter(([_, v]) => v != null && v !== '')
    );
    this.filtersApplied.emit(cleaned as unknown as BeaconQueryFilterDto);
  }
}
